// Filter tree depth limit (zero-based count):
export const DEPTH_LIMIT = 2;
